import { DefaultContentType } from '../../types';
import { FunctionComponent } from 'react';

const DefaultContent: FunctionComponent<DefaultContentType> = ({ title, subtitle, pageAction, children }) => {
  return (
    <div className="container-xl">
      <div
        className={
          'd-flex flex-column justify-content-center flex-md-row justify-content-md-between align-items-md-center py-2'
        }
      >
        {title && (
          <div className={'d-flex align-items-center'}>
            <div className="my-0">
              <h1 className="header fs-3 m-0">{title}</h1>
              <p className="m-0 lh-1">{subtitle}</p>
            </div>
          </div>
        )}
        {pageAction && (
          <div className={`d-flex justify-content-end pt-1`}>
            <>{pageAction}</>
          </div>
        )}
      </div>
      {title && <hr className="my-0" />}
      <div className="container-xl responsive-spacing">{children}</div>
    </div>
  );
};

export default DefaultContent;
